// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { InlineDiv, VisuallyHidden } from 'common/styles/oc-styled-components';
import { formatAverageRating } from 'pages/common/helpers/common-helpers';

import { InfoText, RatingCount, StarIcon } from './styled-components';

const largeFont = '20px';
const largeCountFont = '18px';

// Component
const ResultRating = ({ reviewsRating, reviewsCount, large }) => (
  <InlineDiv>
    <VisuallyHidden>
      Recieved {formatAverageRating(reviewsRating)} out of 5 stars from{' '}
      {reviewsCount}
      patients.
    </VisuallyHidden>
    <StarIcon
      style={large && { fontSize: largeFont }}
      type="star"
      theme="filled"
    />
    <InfoText>
      <strong>{formatAverageRating(reviewsRating)}</strong>
      {reviewsCount 
        && (
          <RatingCount style={large && { fontSize: largeCountFont }}>
            {' '}(<span>{reviewsCount} reviews</span>)
          </RatingCount>
        )
      }
    </InfoText>
  </InlineDiv>
);

ResultRating.propTypes = {
  reviewsRating: PropTypes.number,
  reviewsCount: PropTypes.number,
  large: PropTypes.bool,
};

export default ResultRating;
